import * as React from 'react';
import { AccountSelect } from '../../../../components/AccountSelect';
import { jsx as _jsx } from "react/jsx-runtime";
export var AccountSelectContainer = function AccountSelectContainer(_ref) {
  var accounts = _ref.accounts,
    loadableAccount = _ref.loadableAccount,
    continueByAccount = _ref.continueByAccount,
    continueByPhone = _ref.continueByPhone,
    continueByAccountLoading = _ref.continueByAccountLoading,
    continueByPhoneLoading = _ref.continueByPhoneLoading;
  var handleSelectAccount = function handleSelectAccount(account) {
    if (account) {
      continueByAccount(account);
    } else {
      continueByPhone();
    }
  };
  return /*#__PURE__*/_jsx(AccountSelect, {
    accounts: accounts,
    loadableAccount: loadableAccount,
    continueByPhoneLoading: continueByPhoneLoading,
    continueByAccountLoading: continueByAccountLoading,
    onAccountSelect: handleSelectAccount
  });
};